import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SchedulerComponent } from './scheduler.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { AppointmentComponent } from './appointment/appointment.component';
import PerfectScrollbar from 'perfect-scrollbar';
import { AppointmentMenuComponent } from './appointment-menu/appointment-menu.component';
import { TrancateTextComponent } from './trancate-text/trancate-text.component';
import { AppointmentDetailsComponent } from './appointment-details/appointment-details.component';
import { PagesComponent } from '../pages.component';
import { FutureVisitsComponent } from './future-visits/future-visits.component';
import { FindTimeComponent } from '../find-time/find-time.component';
import { FindTimeResultComponent } from '../find-time-result/find-time-result.component';
import { FindTimeGroupResultComponent } from '../find-time-group-result/find-time-group-result.component';
import { AppointmentSavedMsgComponent } from './appointment-saved-msg/appointment-saved-msg.component';
import { AppointmentCreateComponent } from './appointment-create/appointment-create.component';
import { AuthGuard } from 'src/guards/auth.guard';
import { EnterIdDialogComponent } from './enter-id-dialog/enter-id-dialog.component';
import { NumbersOnlyDirective } from 'src/app/core/directives/numbers-only.directive';
import { PrePaymentRequestComponent } from '../pre-payment-request/pre-payment-request.component';
import { TreatmentSelectionComponent } from './treatment-selection/treatment-selection.component';






export const routes: Routes = [
  {
    path: '', component: PagesComponent, canActivateChild: [AuthGuard], 
    children: [
      { path: '', redirectTo: 'scheduler', pathMatch: 'full' },
      { path: 'scheduler', component: SchedulerComponent },
      { path: 'appointment-details/:id', component: AppointmentDetailsComponent, data: { breadcrumb: 'Appointment-Details' } },
      { path: 'appointment-details', component: AppointmentDetailsComponent, data: { breadcrumb: 'Appointment-Details' } },
      { path: 'create-appointment', component: AppointmentCreateComponent, data: { breadcrumb: 'Appointment-Create' } },
      { path: 'future-visits/:customerid', component: FutureVisitsComponent, data: { breadcrumb: 'Visits' } },
      { path: 'find-time', component: FindTimeComponent },
      { path: 'find-time-result', component: FindTimeResultComponent },
      { path: 'find-time-group-result', component: FindTimeGroupResultComponent },
      { path: 'appointment-saved/:eventID', component: AppointmentSavedMsgComponent },
      { path: 'payment-request', component: PrePaymentRequestComponent, data: { breadcrumb: 'Payment-Request' } }
      
    ]
  }
];


@NgModule({
    declarations: [
        SchedulerComponent,
        AppointmentComponent,
        AppointmentMenuComponent,
        TrancateTextComponent,
        AppointmentDetailsComponent,
        FutureVisitsComponent,
        FindTimeComponent,
        FindTimeResultComponent,
        FindTimeGroupResultComponent,
        AppointmentSavedMsgComponent,
        AppointmentCreateComponent,
        EnterIdDialogComponent,
        TreatmentSelectionComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FormsModule,
        ReactiveFormsModule,
        SharedModule
    ]
})
export class SchedulerModule { }
